import { CountryInterface } from '@app/core/interfaces';
import * as countryActions from '@app/store/my-zone/country/country.actions';
import { NotificationInterface } from 'outshared-lib';

/** @deprecated use OutCountriesModule from outshared-lib */
export interface State {
    entities: CountryInterface[];
    errors: NotificationInterface[];
    loaded: boolean;
    loading: boolean;
}

/** @deprecated use OutCountriesModule from outshared-lib */
export const initialState: State = {
    entities: [],
    errors: [],
    loaded: false,
    loading: false,
};

/** @deprecated use OutCountriesModule from outshared-lib */
export function reducer(state: State = initialState, action: countryActions.CountryActions): State {
    switch (action.type) {
        case countryActions.LOAD_COUNTRIES: {
            return {
                ...state,
                loading: true,
                errors: [],
            };
        }

        case countryActions.LOAD_COUNTRIES_SUCCESS: {
            return {
                ...state,
                entities: action.payload.countries,
                loading: false,
                loaded: true,
                errors: [],
            };
        }

        case countryActions.LOAD_COUNTRIES_ERROR: {
            return {
                ...state,
                loading: false,
                errors: action.payload.errors,
            };
        }

        case countryActions.RESET: {
            return initialState;
        }

        default: {
            return state;
        }
    }
}

/* selectors */
/** @deprecated use OutCountriesModule from outshared-lib */
export const getEntities = (state: State) => state.entities;
/** @deprecated use OutCountriesModule from outshared-lib */
export const getErrors = (state: State) => state.errors;
/** @deprecated use OutCountriesModule from outshared-lib */
export const isLoaded = (state: State) => state.loaded;
/** @deprecated use OutCountriesModule from outshared-lib */
export const isLoading = (state: State) => state.loading;
